export const colors = {
  black: {
    '40': '#151515',
    '50': '#121212',
    '55': '#1C1C1C',
    '60': '#2A2A2A',
    '100': '#B8B8B8',
    'opacity-50': 'rgba(255, 255, 255, 0.5)',
  },
  primary: {
    '100': '#ACDAD0',
    'opacity-100': 'rgba(172, 218, 208, 0.5)',
    '200': '#38AFA2',
    'opacity-200': 'rgba(56, 175, 162, 0.5)',
    '300': '#2B9AAC',
    'opacity-300': 'rgba(43, 154, 172, 0.5)',
    '400': '#224456',
    'opacity-400': 'rgba(34, 68, 86, 0.5)',
  },
}
